"use strict";
/**
 * Именованные наборы `groupId` (слой B прав).
 * Эталон: `USER_GROUP_PERMISSIONS.md` §3, декомпилят 4PDA 1.9.44.
 *
 * ⚠️ Не менять составы без согласования владельца проекта.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BBCODE_HIDE_STAFF_GROUPS = exports.SETTINGS_STAFF_GROUPS = exports.EDIT_MARK_GROUPS = exports.TICKET_MOD_GROUPS = exports.TICKET_REPORT_GROUPS = exports.EDIT_PROFILE_OTHERS_GROUPS = exports.CHANGE_LOGIN_GROUPS = exports.WHO_READS_STAFF_GROUPS = exports.SUPER_MOD_GROUPS = exports.PUNISH_MENU_GROUPS = void 0;
/** Модератор и выше: «Наказать» / заметки в профиле (`K0`, `warnTemplates`). */
exports.PUNISH_MENU_GROUPS = new Set([4, 9, 10, 11, 19]);
/** Супер-уровень: полный бан, расширенные RO/часы (`C0177x.I`, группы 4/10/16). */
exports.SUPER_MOD_GROUPS = new Set([4, 10, 16]);
/** Staff: скрытые читатели темы (`V0.E`, только 4/9/10). */
exports.WHO_READS_STAFF_GROUPS = new Set([4, 9, 10]);
/** Смена логина чужого профиля (`K0` id 8; модератор 9 не может). */
exports.CHANGE_LOGIN_GROUPS = new Set([4, 10]);
/** Редактирование чужого профиля (`K0` id 3). */
exports.EDIT_PROFILE_OTHERS_GROUPS = new Set([4, 9, 10]);
/** Тикеты: «Пожаловаться», если не автор тикета (`O0.b`). */
exports.TICKET_REPORT_GROUPS = new Set([4, 9, 10]);
/** Тикеты: отмена / восстановление / «…и наказать». */
exports.TICKET_MOD_GROUPS = new Set([4, 9, 10]);
/** Редактор: чекбокс «Показывать отметку» при редактировании (`J.w`). */
exports.EDIT_MARK_GROUPS = new Set([4, 10, 16]);
/** Настройки Android `I0` пункт #25 (layout type 4). */
exports.SETTINGS_STAFF_GROUPS = new Set([4, 9, 10, 11, 19]);
/** BBCode `[hide]`: staff видит любой скрытый блок (`hide.ts`, ForPDA admin/mod). */
exports.BBCODE_HIDE_STAFF_GROUPS = new Set([4, 9, 10, 11, 14]);
